import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { EstacaoService } from 'src/services/estacao.service';
import { LogBackupService } from 'src/services/log-backup.service';
import { MonitoramentoService } from 'src/services/monitoramento.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { PessoaService } from 'src/services/pessoa.service';
import { SensorService } from 'src/services/sensor.service';

@Component({
    selector: 'app-log-backup',
    templateUrl: './log-backup.component.html',
    styleUrls: ['./log-backup.component.scss'],
    standalone: false
})
export class LogBackupComponent implements OnInit, AfterViewInit {
  data: any[] = []
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';
  constructor(
    protected _logBackupService: LogBackupService,
    protected permissaoService: PermissoesService,
  ) { }

  ngOnInit(): void {
    this.index()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

index(): void {
this._logBackupService.index().subscribe(json => {
  this.data = json || [];
  setTimeout(() => {
    this.calculateScrollHeight();
  }, 200);
  console.log('json', json)
})
}

}
